<template>
    <div class="chats-panel-body">
        <div class="chats-panel-header" @click="toChats">
            <span class="chats-panel-title">
                {{ $tc('common.messages', 2) }}
                <v-icon size="12">mdi-open-in-new</v-icon>
            </span>
            <span v-if="messagesCount" class="chats-panel-badge">{{ messagesCount }}</span>
        </div>
        <select-option-students underline noList :value="optionChat" :features="chatFeatures"
            @change="optionChat = $event" />
        <div class="chats-panel-list">
            <chats :chat-type="optionChat" component-mode :search-chat="searchChat" :limit="chatsLimit" ref="chats" />
        </div>
        <div class="chats-panel-footer">
            <kimsa-text-field class="chats-search" @change="searchChat = $event" :value="searchChat"
                :placeholder="$t('common.search')" dense />
            <button-tooltip top :tooltip="$t('tooltips.filter')">
                <template v-slot:activator="{ on, attrs }">
                    <button class="panel-footer-btn" v-on="on" v-bind="attrs" @click="showFilterChat">
                        <v-icon size="15">mdi-filter-outline</v-icon>
                    </button>
                </template>
            </button-tooltip>
            <button-tooltip top :tooltip="$t('tooltips.update')">
                <template v-slot:activator="{ on, attrs }">
                    <button class="panel-footer-btn" v-on="on" v-bind="attrs" @click="restartFilters">
                        <v-icon size="15">mdi-refresh</v-icon>
                    </button>
                </template>
            </button-tooltip>
            <button-tooltip top :tooltip="$t('tooltips.add_chat')">
                <template v-slot:activator="{ on, attrs }">
                    <button class="panel-footer-btn panel-footer-btn--accent" v-on="on" v-bind="attrs"
                        @click="showAddChat">
                        <v-icon size="16">mdi-plus</v-icon>
                    </button>
                </template>
            </button-tooltip>
        </div>

        <create-chat-dialog :chatType="optionChat" ref="addChat" @success="onCreatedChat" />
        <filter-chat-dialog :chatType="optionChat" ref="filterChat" @filter="onFilteredChat" />
    </div>
</template>

<script>
import SelectOptionStudents from "@/components/coach/SelectOptionStudents";
import Chats from "@/views/coach/Chats";
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import ButtonTooltip from "@/components/common/ButtonTooltip";
import CreateChatDialog from "@/components/coach/CreateChatDialog";
import FilterChatDialog from "@/components/coach/FilterChatDialog";

export default {
    name: "StudentsChatPanelBody",
    components: {
        SelectOptionStudents,
        Chats,
        KimsaTextField,
        ButtonTooltip,
        CreateChatDialog,
        FilterChatDialog,
    },
    data() {
        return {
            optionChat: 'student',
            searchChat: '',
        }
    },
    computed: {
        chatFeatures() {
            return { group: 'groupChat', team: 'groupChat' }
        },
        messagesCount(vm = this) {
            return Math.max(0, Number(vm.account?.counter?.messages) || 0)
        },
        chatsLimit(vm = this) {
            if (vm.isMobile) return 10
            const height = typeof window !== 'undefined' ? window.innerHeight : 900
            return Math.max(10, Math.floor((height - 170) / 80))
        }
    },
    methods: {
        toChats() {
            this.$router.push({ name: 'coach.students.chats' })
        },
        showAddChat() {
            this.$refs.addChat.show()
        },
        onCreatedChat(chatId) {
            this.$refs.chats.openChat(chatId)
        },
        showFilterChat() {
            this.$refs.filterChat.show()
        },
        onFilteredChat(filter) {
            this.$refs.chats.onFilteredChat(filter)
        },
        restartFilters() {
            this.$refs.chats.resetFilters()
        }
    }
}
</script>

<style scoped>
.chats-panel-body {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.chats-panel-header {
    height: 56px;
    flex-shrink: 0;
    padding: 0 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--v-outline-base);
    cursor: pointer;
    transition: color 0.15s;
}

.chats-panel-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 15px;
    font-weight: 600;
    color: var(--v-txtPrimary-base);
}

.chats-panel-title .v-icon {
    color: var(--v-txtMuted-base);
    opacity: 0.6;
}

.chats-panel-header:hover .chats-panel-title {
    color: var(--v-secondary-base);
}

.chats-panel-badge {
    font-size: 12px;
    font-weight: 700;
    color: var(--v-primary-base);
    background: rgba(204, 255, 51, 0.12);
    border: 1px solid rgba(204, 255, 51, 0.22);
    border-radius: 10px;
    padding: 2px 8px;
}

.theme--light .chats-panel-badge {
    color: var(--v-accent-base);
    background: rgba(51, 153, 153, 0.12);
    border-color: rgba(51, 153, 153, 0.3);
}

.chats-panel-list {
    flex: 1;
    overflow-y: auto;
    padding: 8px 10px;
}

.chats-panel-list ::v-deep [class*="col-"] {
    padding-top: 3px;
    padding-bottom: 3px;
}

.chats-panel-footer {
    flex-shrink: 0;
    padding: 10px 12px;
    border-top: 1px solid var(--v-outline-base);
    display: flex;
    align-items: center;
    gap: 8px;
}

.chats-search {
    flex: 1;
}

.panel-footer-btn {
    width: 32px;
    height: 32px;
    border-radius: 7px;
    background: var(--v-surface2-base);
    border: 1px solid var(--v-outline2-base);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--v-txtMuted-base);
    transition: color 0.15s, background 0.15s, border-color 0.15s;
    flex-shrink: 0;
}

.panel-footer-btn:hover {
    color: var(--v-txtPrimary-base);
    background: var(--v-outline2-base);
}

.panel-footer-btn--accent {
    color: var(--v-primary-base);
    border-color: rgba(204, 255, 51, 0.5);
}

.panel-footer-btn--accent:hover {
    color: var(--v-primary-base);
    background: rgba(204, 255, 51, 0.08);
}

.theme--light .panel-footer-btn--accent {
    color: var(--v-accent-base);
    border-color: rgba(51, 153, 153, 0.5);
}

.theme--light .panel-footer-btn--accent:hover {
    color: var(--v-accent-base);
    background: rgba(51, 153, 153, 0.08);
}
</style>
